import { ImageWidgetSVG } from "assets/icons";

import { Image } from "./Image";
import { ImageLibrary } from "./ImageLibrary";

export const ImageWidget: any = {
  name: "Image",
  component: Image,
  icon: ImageWidgetSVG,
  showOnToolbar: true,
  sizing: {
    minWidth: 400,
    minHeight: 300,
    minAspectRatio: 0.5,
    maxAspectRatio: 1.77,
  },
  defaultState: {},
  defaultSize: {
    aspectRatio: 1.33,
    widthPercentage: 1,
  },
  settings: {
    imageLibrary: {
      editor: ImageLibrary,
      info: {},
      defaultValue: [],
    },
  },
  quickActions: {},
};
